
import anime from '../../node_modules/animejs/lib/anime.es';

export const checkTitlesClicked = ({
    educationDivPositions, 
    experienceDivPositions,
    aboutDivPositions, 
    event}) => {
    const { clientX, clientY } = event;
    let titleClicked = 0;

    anime({targets: '.education', opacity: 0});
    anime({targets: '.experience', opacity: 0});
    anime({targets: '.about', opacity: 0});

    anime({targets: '.details-education', opacity: 0, display: "none"});
    anime({targets: '.details-experience', opacity: 0 });
    anime({targets: '.details-about', opacity: 0 });
    
    if (
        clientX >= educationDivPositions.left &&
        clientX <= educationDivPositions.right &&
        clientY >= educationDivPositions.top &&
        clientY <= educationDivPositions.bottom
    ) {
        anime({targets: '.education', top: "15%", left: "31%", opacity: 1});
        anime({targets: '.details-education', opacity: 1 });
        const elementos = document.querySelectorAll('.details-education');

        elementos.forEach(elemento => {
            elemento.style.display = "block";
        });

        titleClicked = 1;
    }
    
    else if (
        clientX >= experienceDivPositions.left &&
        clientX <= experienceDivPositions.right &&
        clientY >= experienceDivPositions.top &&
        clientY <= experienceDivPositions.bottom
    ) {
        anime({targets: '.experience', top:"15%", left: "31%", opacity: 1});
        anime({targets: '.details-experience', opacity: 1 });
        const elementos = document.querySelectorAll('.details-experience');

        elementos.forEach(elemento => {
            elemento.style.display = "block";
        });

        titleClicked = 2;
    }

    else if (
        clientX >= aboutDivPositions.left &&
        clientX <= aboutDivPositions.right &&
        clientY >= aboutDivPositions.top &&
        clientY <= aboutDivPositions.bottom
    ) {
        anime({targets: '.about', top:"15%", left: "31%", opacity: 1});
        anime({targets: '.details-about', opacity: 1 });
        const elementos = document.querySelectorAll('.details-about');

        elementos.forEach(elemento => {
            elemento.style.display = "block";
        })
        
        titleClicked = 3;
    }

    return titleClicked;
}

export const showTitles = () => {
    anime({targets: '.education', opacity: 1});
    anime({targets: '.experience', opacity: 1});
    anime({targets: '.about', opacity: 1});

    anime({targets: '.details-education', opacity: 0 });
    anime({targets: '.details-experience', opacity: 0 });
    anime({targets: '.details-about', opacity: 0 });
    
    const details = document.querySelectorAll('.details-education, .details-education, .details-about');
    const titulos = document.querySelectorAll('.education, .experience, .about');

    details.forEach(detail => {
        detail.style.display = "none";
    });

    titulos.forEach(titulo => {
        titulo.style = "inherit";
    });
}